import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const LoaderButton = ({ isLoading, children, variant = "primary", disabled, style, className, ...props }) => {
  return (
    <Button
      variant={variant}
      disabled={isLoading || disabled}
      style={{ fontWeight: 600, height: '40px', padding: '0 24px', borderRadius: '8px', ...style }}
      className={className}
      {...props}
    >
      {isLoading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="mr-2"
          />
          {typeof children === 'string' && children.toLowerCase().includes('sign in') 
            ? 'Signing in...' 
            : 'Processing...'}
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoaderButton;
